import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteDiary } from "../../api/CALENDAR/calendar";

export const useDeleteDiary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteDiary,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["calendarEvents"] });
    },
  });
};
